import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import { FormBox, FormFlex, FormGroupAdapter, FormLegend } from 'components/shared/form';

import { SIGNATURE_INITIAL_VALUES, SIGNATURE_CHECKBOX_LABEL_VERSIONS } from 'constants/forms';
import { validateAccepted } from 'utils';

import { LegendFormFlex, StyledTextarea } from '.';

const propTypes = {
  disabled: PropTypes.bool,
  signatureVersion: PropTypes.string,
  acknowledgmentCheckboxesVersion: PropTypes.string,
};

const defaultProps = {
  disabled: true,
  signatureVersion: 'v1',
  acknowledgmentCheckboxesVersion: 'v2',
};

function AccurateInformation({ disabled, signatureVersion, acknowledgmentCheckboxesVersion }) {
  return (
    <Fragment>
      <LegendFormFlex justifyContent="space-between">
        <FormBox>
          {signatureVersion === 'v1' ? (
            <FormLegend>The Information Provided is True and Accurate</FormLegend>
          ) : (
            <FormLegend>True And Accurate Information</FormLegend>
          )}
        </FormBox>
      </LegendFormFlex>

      <FormFlex>
        <FormBox width={1}>
          <StyledTextarea rows={8} disabled value={SIGNATURE_INITIAL_VALUES[signatureVersion].accurateInformation} />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <Field
            name="application.borrower.accurateInformation"
            type="checkbox"
            label={SIGNATURE_CHECKBOX_LABEL_VERSIONS[acknowledgmentCheckboxesVersion].accurateInformation}
            inlineGroup
            labelOrder={1}
            errorOrder={2}
            required
            disabled={disabled}
            validate={validateAccepted()}
            component={FormGroupAdapter}
          />
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

AccurateInformation.propTypes = propTypes;
AccurateInformation.defaultProps = defaultProps;

export default AccurateInformation;
